import React from 'react';
import TableSortInputFilter from 'components/customComponents/Controls/tableSortInputFilter';

export const tableFilter = (filterable: boolean, filterTitle: string) => (event: any) =>
  <TableSortInputFilter event={event} title={filterTitle} showSearchInput={filterable} />;
